


import { setGetMailingStatisticsScrollerUsersDepositsAction } from '../action';
import { getMailingStatisticsScrollerUsersDeposits } from '../api/getMailingStatisticsScrollerUsersDeposits';

export const setGetMailingStatisticsScrollerUsersDeposits = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersDeposits({
                ...params,
                status: 'paid'
            });

            dispatch(setGetMailingStatisticsScrollerUsersDepositsAction(data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}